import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      borderRadius: theme.shape.borderRadiusSmall,
      overflow: 'hidden',
      margin: theme.spacing(1, 0, 8),
      display: 'flex',
      columnGap: theme.spacing(0.5),
    },
    loader: {
      width: ({ loadersCount }) => `${100 / loadersCount}%`,
      height: 16,
      backgroundColor: COLORS.gray.gray80,
    },
  }),
  { name: 'Loaders' }
);
